export default {"src":"/_next/static/media/share_white.83f0cc13.svg","height":19,"width":16,"blurWidth":0,"blurHeight":0};